import { logger } from '@services/logger/logger.service';
import {
  type RealtimeTrustedContactRequestUpdated,
  realtimeTrustedContactRequestUpdated,
} from '@store/externalEvents/externalEvents.action';
import type { QueryClient } from '@tanstack/react-query';
import { invalidateDraftDocumentsInCache } from '@utils/caching.util';
import { all, getContext, takeEvery } from 'redux-saga/effects';

function receiveTrustedContactRequestUpdated() {
  return function* saga({ payload }: ReturnType<RealtimeTrustedContactRequestUpdated>) {
    const queryClient: QueryClient = yield getContext('queryClient');
    try {
      const documentId = payload.resource.id;

      if (!documentId) return;

      invalidateDraftDocumentsInCache({ documentId, queryClient });
    } catch (err) {
      logger.error(
        'LOGIC',
        '[realtime] Failed to invalidate cache for trusted contact update',
        err,
      );
    }
  };
}

export function* trustedContactRealtimeSagas() {
  yield all([
    takeEvery(realtimeTrustedContactRequestUpdated.type, receiveTrustedContactRequestUpdated()),
  ]);
}
